import panomobiLogo from "@/assets/panomobi.png";
import enlargeLogo from "@/assets/enlarge.png";

/** 按构建环境切换品牌展示 */
const apiBase = process.env.VUE_APP_API_BASE || "https://api.panomobi.com/api";
const isEnlarge = apiBase.includes("enlargebusiness");

export const brand = {
  /**
   * 应用名必须与 Google Cloud OAuth 同意屏幕里的应用名完全一致
   * enlarge OAuth 配置为 Enlarge（非 ENLARGE）
   */
  name: isEnlarge ? "Enlarge" : "PanoMobi",
  /** 协议页公司名 */
  legalName: isEnlarge ? "Enlarge" : "Panomobi",
  /** 版权主体 */
  copyrightName: isEnlarge ? "Enlarge Co., Limited" : "PanoMobi Co., Limited",
  /** 公开站点根 URL */
  siteUrl: isEnlarge
    ? "https://hw.enlargebusiness.com"
    : "https://hw.panomobi.com",
  /** 品牌 logo */
  logo: isEnlarge ? enlargeLogo : panomobiLogo,
  showLogo: true,
  apiBase,
  isEnlarge,
};

export default brand;
